import React, { useEffect, useState } from "react";
import TipsCard from "./_tips-card";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles((theme) => ({
  carousal: {
   "& .react-multi-carousel-dot--active button" :{
      backgroundColor: theme.palette.eSecondary?.base
  },
  "& .react-multi-carousel-dot button":{
      border:"0px",
      height:"10px",
      width:"10px"
  },
  "& .react-multi-carousel-dot-list":{
      bottom:"12px"
  },
  "& .react-multi-carousel-track":{
     height:"100%"
  },
  height:"100%"
  },
}));

export default function ETipsBanner({ data }) {
  let classes = useStyle();
  let [carousalData, setCarousalData] = useState();
  let [play,setPlay]=useState(true);
  useEffect(() => {
    if (data) {
      setCarousalData(data);
    }
  }, [data]);
  const responsive = {
    mobile: {
      breakpoint: { max: 3000, min: 0 },
      items: 1,
      slidesToSlide: 1 
    }
  };

  return (
    <>
      {carousalData && (
        <Carousel
          showDots={carousalData.length==1?false:true}
          autoPlay={play}
          arrows={false}
          autoPlaySpeed={4000}
          responsive={responsive}
          className={classes.carousal}
          infinite={carousalData.length==1?false:true}
        >
          {carousalData.map((eachItem, index) => {
            return (
              <TipsCard
                item={eachItem}
                setPlay={setPlay}
                play={play}
              />
            );
          })}
        </Carousel>
      )}
    </>
  );
}
